"use client";

import Image from "next/image";
import Link from "next/link";

import { ArrowIcon } from "@/app/(public)/waitlist/_components/arrow-icon";
import { WAITLIST_EMAIL_INPUT_ID } from "@/app/(public)/waitlist/_components/waitlist-constants";
import { ROUTES } from "@/app/_libs/constants/routes";
import { useIsMobile } from "@/hooks/use-mobile";

type PublicNavbarProps = {
  /** When provided, "Get early access" scrolls to the waitlist form. Otherwise it links to /waitlist. */
  onEarlyAccessClick?: () => void;
};

export function PublicNavbar({ onEarlyAccessClick }: PublicNavbarProps) {
  const isMobile = useIsMobile();

  const earlyAccessClassName =
    "waitlist-early-access-button inline-flex shrink-0 cursor-pointer items-center gap-1.5 px-2 py-1 text-xs font-normal transition-colors min-[400px]:gap-2 min-[400px]:px-2 min-[400px]:py-1 min-[400px]:text-sm md:px-4 md:py-1 md:text-base";

  return (
    <header className="relative z-10 flex items-center justify-between gap-3 px-5 py-5 sm:px-6 sm:py-6 md:px-10 md:py-8 lg:px-14">
      <Link href={ROUTES.WAITLIST} className="inline-flex shrink-0" aria-label="NOMISS home">
        <Image
          src="/header-branding.svg"
          alt="NOMISS!"
          width={isMobile ? 180 : 220}
          height={20}
          className="h-auto"
          priority
        />
      </Link>

      {onEarlyAccessClick ? (
        <label
          htmlFor={WAITLIST_EMAIL_INPUT_ID}
          onClick={onEarlyAccessClick}
          className={earlyAccessClassName}>
          <span className="whitespace-nowrap">Get early access</span>
          <ArrowIcon className="text-brand-lime size-3.5 min-[400px]:size-4" />
        </label>
      ) : (
        <Link href={ROUTES.WAITLIST} className={earlyAccessClassName}>
          <span className="whitespace-nowrap">Get early access</span>
          <ArrowIcon className="text-brand-lime size-3.5 min-[400px]:size-4" />
        </Link>
      )}
    </header>
  );
}
